module.exports = __webpack_public_path__ + "img/brand-fuchs.71006c02.png";